<template>
  <!-- 页面底部 -->
  <div class="page_bottom_box">
    <div class="page_con_center">
      <div class="bottom_item bottom_item_top">
        <div class="logo">
          <img src="@/assets/image/bottom_logo.png" />
        </div>
        <div class="center_text">
          <div class="label">联系我们</div>
          <div class="text">商务热线：132-8260-1882</div>
          <div class="text">邮箱：email@yunlingtec.com</div>
          <div class="text">地址：浙江省台州市椒江区中建城市花园A101号4楼</div>
        </div>
        <div class="codes_box">
          <div class="code_item">
            <div class="code_box">
              <el-popover
                placement="top"
                trigger="hover"
                popper-class="bottom_pic"
                :popper-options="{
                  boundariesElement: 'body',
                  gpuAcceleration: false,
                }"
              >
                <img src="@/assets/image/code_qywx.png" />
                <img src="@/assets/image/code_qywx.png" slot="reference" />
              </el-popover>
            </div>

            <div class="label">企业微信</div>
          </div>
          <div class="code_item">
            <div class="code_box">
              <el-popover
                placement="top"
                trigger="hover"
                popper-class="bottom_pic"
                :popper-options="{
                  boundariesElement: 'body',
                  gpuAcceleration: false,
                }"
              >
                <img src="@/assets/image/code_gzh.png" />
                <img src="@/assets/image/code_gzh.png" slot="reference" />
              </el-popover>
            </div>

            <div class="label">公众号</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_item bottom_item_bottom">
      <div class="page_con_center">
        <div class="text">
          © 2023<span v-if="nowYear != 2023">{{ "-" + nowYear }}</span>
          浙江云翎信息技术有限公司 版权所有
        </div>
        <a href="https://beian.miit.gov.cn/" target="_blank" class="text text1">
          浙ICP备2023003449号-1
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nowYear: 2023,
    };
  },
  methods: {},
  created() {
    this.nowYear = new Date().getFullYear();
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.page_bottom_box {
  float: left;
  width: 100%;
  height: 251px;
  background: #171b27;
  position: relative;
  z-index: 999;
  .bottom_item {
    float: left;
    width: 100%;
    &.bottom_item_top {
      height: 196px;
      @include flexBoxCenter(flex-start, space-between);
    }
    &.bottom_item_bottom {
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      height: 55px;
      padding: 14px 0;
      .page_con_center {
        @include flexBoxCenter(center, center);
      }
      .text {
        font-size: 12px;
        line-height: 26px;
        color: #9f9faa;
        &.text1 {
          color: #797e8f;
          margin-left: 24px;
          cursor: pointer;
          &:hover {
            color: #9f9faa;
          }
        }
      }
    }
  }
  .logo {
    float: left;
    width: 201px;
    height: auto;
    margin-top: 52px;
    img {
      float: left;
      width: 100%;
      height: auto;
    }
  }
  .center_text {
    float: left;
    margin-top: 33px;
    @include flexBoxCenter(flex-start);
    flex-flow: column;
    & > div {
      float: left;
    }
    .label {
      color: #fff;
      font-size: 14px;
      margin-bottom: 3px;
    }
    .text {
      color: #9f9faa;
      font-size: 14px;
      margin-top: 17px;
    }
  }
  .codes_box {
    @include flexBoxCenter(flex-start);
    margin-top: 30px;
    .code_item {
      float: left;
      width: 120px;
      height: auto;
      & + .code_item {
        margin-left: 32px;
      }
      .code_box {
        float: left;
        width: 100%;
        height: 121px;
        @include backgroundUrl("code_border.png");
        @include flexBoxCenter(center, center);
      }
      img {
        width: 100px;
        height: 100px;
        float: left;
      }
      .label {
        float: left;
        width: 100%;
        text-align: center;
        color: #9f9faa;
        font-size: 14px;
        line-height: 26px;
        
      }
    }
  }
}
</style>
